import { Location } from "@/models/jobs/Location";

export class JobAlertLocationInfo {
  public latLong: Location = new Location();
  public radius:number=0;
  public locationType: string = '';
  public location: string = '';
  public locShortName: string= '';

}
